// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import App from './App'
import router from './router/index'

// vuex
import { store } from '@/store/store'

// bootstrap-vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

//////////////////////
// modulos adicionales
//////////////////////

// vue-progressbar
import VueProgressBar from 'vue-progressbar'
// opciones de progress bar
const optionsPb = {
	color: '#bffaf3',
	failedColor: '#874b4b',
	thickness: '5px',
	transition: {
		speed: '0.05s',
		opacity: '0.6s',
		termination: 300
	},
	autoRevert: true,
	location: 'top',
	inverse: false,
	autoFinish: false,
}
Vue.use(VueProgressBar, optionsPb)

// vue-backtotop
import BackToTop from 'vue-backtotop'
Vue.use(BackToTop)

// @dsb-norge/vue-keycloak-js
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'

// axios
import axios from 'axios'
axios.defaults.baseURL = process.env.VUE_APP_URL_API;
//axios.defaults.maxContentLength = Infinity;
//axios.defaults.maxBodyLength = Infinity;
axios.interceptors.response.use(function (response) {
	// interceptar response y detectar si el usuario tiene autorizacion
	if ("festado" in response.data) {
		if ("resultado" in response.data.festado) {
			if ("codigo" in response.data.festado.resultado) {
				if (response.data.festado.resultado.codigo == "299") {
					router.push({ name: 'Error' })
				}
			}
		}
	}
	return response;
}, function (error) {
	// interceptar error
	return Promise.reject(error);
});
// se agrega bearer token en cada llamada al api
function tokenInterceptor() {
	axios.interceptors.request.use(config => {
		config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
		return config
	}, error => {
		return Promise.reject(error)
	})
}

// moment
import moment from 'moment'
moment.locale('es');
Vue.prototype.$moment = moment

// numeral
import numeral from 'numeral'
numeral.register('locale', 'es-cl', {
	delimiters: {
		thousands: process.env.VUE_APP_LOCALE.toString()==='es-cl'? '.' : ',',
		decimal:   process.env.VUE_APP_LOCALE.toString()==='es-cl'? ',' : '.'
	},
	abbreviations: {
		thousand: 'k',
		million: 'm',
		billion: 'b',
		trillion: 't'
	},
	ordinal: function (number) {
		return number === 1 ? 'er' : 'ème';
	},
	currency: {
		symbol: '$'
	}
});
numeral.locale('es-cl');
Vue.prototype.$numeral = numeral

// vue-data-tables
import VueDataTables from 'vue-data-tables'
Vue.use(VueDataTables)

// vue-inputmask
const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)

// vue-session
import VueSession from 'vue-session'
Vue.use(VueSession)

// element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
locale.use(lang)

// vue-notifications
import VueNotifications from 'vue-notifications'
const optionsNotifications = {
	success: toast,
	error: toast,
	info: toast,
	warn: toast
}
Vue.use(VueNotifications, optionsNotifications)

// mini-toastr
import miniToastr from 'mini-toastr'
const toastTypes = {
	success: 'success',
	error: 'error',
	info: 'info',
	warn: 'warn'
}
miniToastr.init({ types: toastTypes, allowHtml: true })
function toast({ title, message, type, timeout, cb }) {
	return miniToastr[type](message, title, timeout, cb)
}
Vue.use(miniToastr)




// parametros globales
Vue.prototype.$globales = {
	separadorMiles: '.',
	separadorDecimales: ','
}


Vue.use(VueKeyCloak, {
	config: {
		realm: process.env.VUE_APP_URL_OAUTH_REALM,
		url: process.env.VUE_APP_URL_OAUTH_SERVER,
		clientId: process.env.VUE_APP_URL_OAUTH_CLIENT_ID,
	},
	init: {
		onLoad: 'login-required',
		redirectUri: window.location.origin + '/',
		checkLoginIframe: false,
		useNonce: false,
		//flow: 'implicit'
	},
	// solo cuando keycloak haya completado el proceso de autentificación, se procede con la carga de la instancia de vue
	onReady: (keycloak) => {
		//console.log(keycloak);
		tokenInterceptor();
		/* eslint-disable no-new */
		new Vue({
			el: '#app',
			store,
			router,
			template: '<App/>',
			components: {
				App
			},
			mounted() {
				this.$session.start();
				this.$session.set("mail", keycloak.idTokenParsed.email);
				this.$session.set("nombreUsuario", keycloak.idTokenParsed.given_name);
				this.$session.set("logout", keycloak.createLogoutUrl());
				// obtener usuario interno
				axios
					.post('spoc/modppentry', {
						"p_email": keycloak.idTokenParsed.email,
						"p_metodo": "modppc.recuperar_usuario_mail",
						"p_args_in": JSON.stringify({
							"p_mail": keycloak.idTokenParsed.email
						})

					})
					.then(response => {
						this.$session.set("usuarioInterno", response.data.festado.usuario.valor);
					})
					.catch(error => console.log(error))
				// obtener foto
				axios
					.post('active-directory/obtener-foto', {
						"email": keycloak.idTokenParsed.email
					})
					.then(response => {
						this.$session.set("foto", response.data.foto);
					})
					.catch(error => console.log(error))
			}
		})
	}
})
